'use client';

import { EmbeddedComponentRegion } from '@/components/region/embedded-component-region';
import {
    GLOBAL_FOOTER_LINK_REGION_KEYS,
    type GlobalFooterLinkRegionKey,
} from '@/extensions/snk/lib/global-footer';
import type { ComponentWithComponentData } from '@/lib/page-designer/component-loader.server';

type LinkColumnsProps = {
    footerRegions: Record<
        GlobalFooterLinkRegionKey,
        Promise<ComponentWithComponentData | null> | ComponentWithComponentData | null | undefined
    >;
};

export const LinkColumns = ({ footerRegions }: LinkColumnsProps) => {
    return (
        <div data-slot="global-footer-link-columns" className="grid grid-cols-1 lg:grid-cols-5 lg:pt-8 gap-x-4">
            {GLOBAL_FOOTER_LINK_REGION_KEYS.map((regionId) => (
                <div key={regionId}>
                    <EmbeddedComponentRegion
                        component={footerRegions[regionId]}
                        regionId={regionId}
                        fallbackElement={null}
                        errorElement={null}
                    />
                </div>
            ))}
        </div>
    );
};
